module.exports = __webpack_public_path__ + "static/media/TallCabinet_After.652fd0b2.jpg";